export const SendDisclosuresFormTestIds = {
  ORDER_CREDIT_BUTTON: 'send-disclosures-form.order-credit-button',
};
